module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-top": "130px"
    },
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', [_vm._v("“I came from an era when you had to be nice to men. I remember my mom saying that to me. She said, ‘You be a nice girl and if a man tells you to do this or that, you do it. OK?’ And let me tell you, that has its effect. It’s lasting. It took me a very, very, very long time to feel independent.”")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("—Rita Moreno")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Associated Press interview, published in the "), _c('em', [_vm._v("San Francisco Chronicle")]), _vm._v(", February 25, 2019.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 66
// module chunks = 0